import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {serviceMotionList} from '../../utils/serviceMotionList';

import FeatureCardBox from '../common/FeatureCardBox';

import {ReactComponent as FeedbackExampleImg} from '../../assets/admin03/feedback-example.svg';
import {ReactComponent as FeedbackExampleMediumImg} from '../../assets/admin03/feedback-example-md.svg';
import {ReactComponent as FeedbackImg} from '../../assets/admin03/feedback.svg';
import {ReactComponent as LogExampleImg} from '../../assets/admin03/log-example.svg';
import {ReactComponent as LogExampleMediumImg} from '../../assets/admin03/log-example-md.svg';

export default function Admin03() {
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');

    const getFirstSubTitle = () => {
        if (mobileMedium) return <>피드백을 모니터링하며 빠르게 AI 성능을 개선<br />하세요</>;
        return '피드백을 모니터링하며 빠르게 AI 성능을 개선하세요'
    };

    const getFirstIamge = () => {
        if (mobileMedium) return FeedbackExampleMediumImg;
        return FeedbackExampleImg;
    };

    const getSecondTitle = () => {
        if (mobileMedium) return <>모든 답변의 과정 로그와 SQL을 확인<br />하세요</>;
        return '모든 답변의 과정 로그와 SQL을 확인하세요'
    };

    const getSecondSubTitle = () => {
        if (mobileMedium) return <>답변 과정을 분석하여 개선점을 쉽게 찾아<br />보세요</>;
        return '답변 과정을 분석하여 개선점을 쉽게 찾아보세요'
    };

    const getSecondIamge = () => {
        if (mobileMedium) return LogExampleMediumImg;
        return LogExampleImg;
    };

    const dataMap = [
        { 
            type: 'feedback-example',
            title: '사용자들의 피드백을 반영하세요',
            subTitle: getFirstSubTitle(),
            Image: getFirstIamge()
        },
        { 
            type: 'log-example',
            title: getSecondTitle(),
            subTitle: getSecondSubTitle(),
            Image: getSecondIamge()
        }
    ];

    return (
        <div>
            <FeatureCardBox
                type='admin-feedback'
                IconImage={FeedbackImg}
                keyword='피드백 관리'
                title={<>모든 답변의 흐름과 피드백을<br />실시간으로 확인하세요!</>}
                featureCardList={dataMap}
                titleMotion={serviceMotionList.titleMotion}
                cardMotion={serviceMotionList.cardMotion}
            />
        </div>
    );
}
